module.exports = __webpack_public_path__ + "img/pg2_2.765ef45f.png";